import { ComponentMeta, ComponentStory } from "@storybook/react";
import { SearchIcon } from "lucide-react";
import React from "react";
import Textarea from "./Textarea";

type Story = ComponentStory<typeof Textarea>;

const commonArgs: React.ComponentProps<typeof Textarea> = {};

export default {
    title: "Form Components/Textarea",
    component: Textarea,
    args: commonArgs
} as ComponentMeta<typeof Textarea>;

const Template: Story = args => (
    <div style={{ width: "360px" }}>
        <Textarea {...args} />
    </div>
);

export const Default = Template.bind({});

export const Placeholder = Template.bind({});
Placeholder.args = {
    defaultValue: undefined,
    placeholder: "Textarea"
};

export const Focus = Template.bind({});
Focus.args = {
    autoFocus: true
};

export const WithError = Template.bind({});
WithError.args = {
    error: (
        <>
            Available quantity of Product 1 at BER2: <strong>2000</strong>
        </>
    )
};

export const WithErrorAsBoolean = Template.bind({});
WithErrorAsBoolean.args = {
    error: true
};

export const Disabled = Template.bind({});
Disabled.args = {
    disabled: true
};

export const WithField = Template.bind({});
WithField.args = {
    label: "Leading label",
    helperText: "Helper text"
};

export const WithIcon = Template.bind({});
WithIcon.args = {
    icon: <SearchIcon />,
    placeholder: "Search",
    defaultValue: ""
};
